import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';

import './PartiesCases.less';

class PartiesCases extends Component {
  getPartiesTableBody = (data) => {
    if (data.length === 0) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }

    if (data.empty) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {data.empty}
          </div>
        </div>
      );
    }

    const rows = data.map((item, key) => (
      <tr key={key}>
        <td valign="top" >{this.getCardBody(item.party)}</td>
        <td valign="top">represented by</td>
        <td valign="top">
          {this.getAssociatedBody(item.associated)}
        </td>
      </tr>
    ));
    return (
      <div>
        <FilterTable premiumSearch={{ uuid: this.props.case_uuid, query: this.props.type }}>
          <table className="sticky-enabled tablesorter">
            <thead />
            <tbody>
              { rows }
            </tbody>
          </table>
        </FilterTable>
      </div>
    );
  };

  getAssociatedBody = data => (
    data.map((item, key) => (this.getCardBody(item, key)))
  );

  getAddress = address => (
    address.split('\n').map((item, key) => (<span key={key}>{item}<br /></span>))
  )
  getUserEditLinkIfAdmin = (userId, name) => {
    const link = `/user/${userId}/edit`;
    if (this.props.currentUser === '1' && userId) {
      return (
        <b>
          <a href={link} target="_blank">
            {name}
          </a>
        </b>
      );
    }
    return (
      <b>{name}</b>
    );
  }

  getCardBody = (data, key) => (
    <div className="ir-search-card" key={key}>
      {this.getUserEditLinkIfAdmin(data.uuid,data.name)}<br />
      {data.address && this.getAddress(data.address)}
      {data.phone && `t: ${data.phone}`}
      {data.phone && <br />}
      {data.fax && `f: ${data.fax}`}
      {data.fax && <br />}
      {data.email && data.email}
      {data.email && <br />}
      {data.ssn && `SSN: ${data.ssn}`}
      {data.ssn && <br />}
      {data.itin && `ITIN: ${data.itin}`}
      {data.itin && <br />}
      {data.ein && `Tax ID / EIN: ${data.ein}`}
      {data.ein && <br />}
      {data.role && <i>({data.role})</i>}
      {data.role && <br />}
      {data.lead && <i>({data.lead})</i>}
      {data.lead && <br />}
      {data.added_date && <i>Added: {data.added_date}</i>}
      {data.assigned_date && <i>Assigned: {data.assigned_date}</i>}
      {data.assigned_date && <br />}
    </div>
  );

  render() {
    if (!this.props.dataReady) return <LoadingBar />;
    const alertError = this.props.error ? <AlertError errors={this.props.error} /> : null;

    const tableData = this.props.parties || [];
    return (
      <div className={this.props.type}>
        {alertError}
        {this.getPartiesTableBody(tableData)}
        <UpdateFromPacer
          pacerUpdateHandler={this.props.purchaseData}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated} />
      </div>
    );
  }
}

PartiesCases.defaultProps = {
  error: null,
  receipt: null,
  type: 'parties',
};

PartiesCases.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  parties: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  currentUser: PropTypes.any,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
};

export default PartiesCases;



// WEBPACK FOOTER //
// ./src/components/case/parties/PartiesCases.js